import React from "react";
import { Script, Slice } from "gatsby";
import SSRProvider from "react-bootstrap/SSRProvider";

import "../../styles/main.scss";
import Menu from "./menu";
import Breadcrumbs from "./breadcrumbs";

function Layout({
  children,
  title,
  location,
  showSidebar,
  handleShowSidebar,
  pageContext,
}) {
  return (
    <>
      <SSRProvider>
        <div>
          <span id="#top" aria-hidden="true"></span>
          <Menu
            pageTitle={title}
            currentPath={location?.pathname}
            showSidebar={showSidebar}
            handleShowSidebar={handleShowSidebar}
          />
          {children}
          <div className="border-bottom border-top bg-white">
            <div className="container py-2">
              <div className="d-flex flex-row offset-lg-3 col-lg-8 justify-content-between">
                <Breadcrumbs
                  crumbs={pageContext?.breadcrumb?.crumbs}
                  pageTitle={title}
                />
                <a
                  href="#top"
                  className="flex-shrink-0"
                  style={{ height: "1.75em" }}
                >
                  To top
                </a>
              </div>
            </div>
          </div>
          <Slice alias="footer" allowEmpty={true} />
        </div>
      </SSRProvider>
      <Script defer data-domain="mcg.uva.nl" src="https://plausible.io/js/script.js" />
    </>
  );
}

export default Layout;
